<template>
    <Modal v-model="modal"
           title="重置阿里云终端密码"
           :mask-closable="false"
           :z-index="1500"
           @on-cancel="cancel">
        <Form ref="form"
              :label-width="100"
              :model="formData"
              :rules="rules">
            <FormItem prop="newPassword"
                      label="新密码：">
                <Input type="password"
                       v-model="formData.newPassword"></Input>
                <div class="rc-label-warning">
                    <span class="icon">
                        <i class="icon-warning"></i>&nbsp;</span>
                    <span>限制为6位，支持数字和字母，不支持特殊字符</span>
                </div>
            </FormItem>
            <FormItem prop="surePassword"
                      label="确认密码：">
                <Input type="password"
                       v-model="formData.surePassword"></Input>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">取消</Button>
            <Button type="primary"
                    @click="submit"
                    :loading="loading">保存</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    props: ['cloudID', 'hostID'],
    data () {
        const validatePass = (rule, value, callback) => {
            if (value.length !== 6) {
                callback(new Error('限制为6位'))
            } else if (!/^[0-9a-zA_Z]+$/.test(value)) {
                callback(new Error('支持数字和字母，不支持特殊字符'))
            } else {
                callback()
            }
        }
        const validateSurePass = (rule, value, callback) => {
            if (value !== this.formData.newPassword) {
                callback(new Error('两次密码输入不一致！'))
            } else {
                callback()
            }
        }
        return {
            modal: false,
            loading: false,
            formData: {
                newPassword: '',
                surePassword: ''
            },
            rules: {
                newPassword: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                surePassword: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { validator: validateSurePass, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        openModal () {
            this.modal = true
        },
        cancel () {
            this.modal = false
            this.$refs.form.resetFields()
        },
        submit () {
            this.loading = true
            this.$refs.form.validate(v => {
                if (v) {
                    this.axios.put(this.urlFormat(API.PUT_HOSTS_CONSOLE_CODE, false), {
                        vncPassword: this.formData.newPassword,
                        cloudEnvId: this.cloudID,
                        instanceId: this.hostID
                    }).then(res => {
                        this.loading = false
                        this.$emit('resetPasword', this.formData.newPassword)
                        this.cancel()
                    }).catch(e => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        }
    }
}
</script>
